//Basic reducer actions
export const SET_NOTIFICATIONS_DATA = 'SET_NOTIFICATIONS_DATA'
export const TOGGLE_NOTIFICATIONS_SHOW = 'TOGGLE_NOTIFICATION_SHOW'
export const SET_NOTIFICATION_SEEN = 'SET_NOTIFICATION_SEEN'
export const SET_NOTIFICATION_UNSEEN = 'SET_NOTIFICATION_UNSEEN'
